export const PLACES_API_CONFIG = {
  apiKey: "AIzaSyC9fWHC_daJJZWM8W-N8zDB5gJEcsetKfg",
  autocompleteUrl: "https://places.googleapis.com/v1/places:autocomplete",
  placeDetailsUrl: "https://places.googleapis.com/v1/places",
  fieldMask: "id,formattedAddress,addressComponents",
  defaultDebounceMs: 500,
  defaultMinQueryLength: 2,
  staleTime: 5 * 60 * 1000,
} as const;

export const DEFAULT_ADDRESS_TYPES = ["street_address", "premise", "subpremise"] as const;
